import cn from 'classnames';
import Delivery from './frames/Delivery';
import Prices from './frames/Prices';

import styles from './index.module.scss';
import { useWindowWidth } from '@shared/hooks';

const Information = ({ order }) => {

	const windowWidth = useWindowWidth();

	

	return (
		<>
			{windowWidth > 768 ? (
				<>
					<section className={styles.information} >
						<div className={styles.content}>
							<Delivery order={order} />
							<Prices order={order} />
						</div>
					</section>
				</>
			) : (
				<>
					<section className={cn(styles.information, styles.information__first)} >
						<div className={styles.content}>
							<Delivery order={order} />
						</div>
					</section>
					<section className={styles.information}>
						<div className={styles.content}>
							<Prices order={order} />
						</div>
					</section>
				</>
			)}
		</>
	);
};

export default Information;
